/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-debugger,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

class ServiceDetailsController {

    /* @ngInject */

    constructor($log, $q, $timeout, MerchantConfigurationService,
                MerchantVasService, StorageService, ModalFactory, TermsService,
                NewTokenService) {
        const that = this;
        that.currentVasId = MerchantVasService.getVasesTypes()['ORDER_AND_DELIVERY'];
        that.currentWalletId = NewTokenService.getMerchantWalletID();
        that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
        that.configuration = {
            'enabled': true,
            'invoiceEnabled': true,
            'taxRate': 10,
            'menu': '58935e79bee23bee57075894',
            'weeklyHours': [{
                'dayOfWeek': 'MONDAY',
                'openingTime': {
                    'hour': 10,
                    'minute': 0,
                    'second': 0,
                    'nano': 0
                },
                'closingTime': {
                    'hour': 20,
                    'minute': 0,
                    'second': 0,
                    'nano': 0
                },
                'maxItems': 60
            }, {
                'dayOfWeek': 'TUESDAY',
                'openingTime': {
                    'hour': 10,
                    'minute': 0,
                    'second': 0,
                    'nano': 0
                },
                'closingTime': {
                    'hour': 20,
                    'minute': 0,
                    'second': 0,
                    'nano': 0
                },
                'maxItems': 60
            }],
            'deliveryFee': 5,
            'deliveryArea': 'Radius or broken line from the point of sale',
            'itemsPerSlot': 20
        };

        const save = () => {
            MerchantVasService.configureVas(that.configuration, that.currentVasId);
        };

        const init = () => {
            var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
            MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
                .then(
                    (response) => {
                        that.currentVas = response.data;
                        that.configuration = that.currentVas.configuration;
                    },
                    (error) => {
                        alert("error retrieving the vas!");
                    }
                );
        };

        that.$onInit = init;


    }

}

export default ServiceDetailsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/details/details.controller.js
 **/